import React, { useEffect } from "react";
import { Modal, Form, InputNumber, Button, Divider } from "antd";
import { TrophyOutlined, SaveOutlined } from "@ant-design/icons";
import "./updateRankingPopup.css";

const RankingEditModal = ({
  visible,
  onClose,
  builderData,
  onSave,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible && builderData) {
      form.setFieldsValue({
        ranking: builderData.ranking || 0
      });
    } else if (visible) {
      form.resetFields();
    }
  }, [visible, builderData, form]);

  const handleFinish = (values) => {
    const payload = {
      builder_id: builderData._id,
      ranking: parseInt(values.ranking)
    };
    onSave(payload);
  };

  return (
    <Modal
      title={
        <div className="ranking-edit-modal-header-content">
          <TrophyOutlined className="ranking-edit-modal-header-icon" style={{ color: "white" }} />
          <span style={{ color: "white" }}>
            UPDATE BUILDER RANKING
          </span>
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      destroyOnClose
      width={600}
      className="ranking-edit-modal-override"
      styles={{
        header: {
          background: "#0D152B",
          borderRadius: "12px 12px 0 0",
          padding: "20px 24px",
          borderBottom: "none",
        },
        body: {
          padding: "24px",
          background: "#fafafa",
        },
      }}
    >
      <div className="ranking-edit-modal-form">
        <Form
          form={form}
          layout="vertical"
          onFinish={handleFinish}
        >
          {/* Builder Information Display */}
          <div className="ranking-edit-section">
            <h3 className="ranking-edit-section-header">Builder Information</h3>
            <div className="builder-info-display">
              <div className="builder-info-item">
                <span className="builder-info-label">Builder Name:</span>
                <span className="builder-info-value">{builderData?.brand_name || "N/A"}</span>
              </div>
              <div className="builder-info-item">
                <span className="builder-info-label">Organization:</span>
                <span className="builder-info-value">{builderData?.organization_name || "N/A"}</span>
              </div>
              <div className="builder-info-item">
                <span className="builder-info-label">Current Ranking:</span>
                <span className="builder-info-value builder-current-rank">
                  {builderData?.ranking || "Not Set"}
                </span>
              </div>
            </div>
          </div>

          <Divider className="ranking-edit-divider" />

          {/* Ranking Input Section */}
          <div className="ranking-edit-section">
            <h3 className="ranking-edit-section-header">Update Ranking</h3>
            <Form.Item
              label="New Ranking Position"
              name="ranking"
              rules={[
                { required: true, message: "Please input ranking" },
                { type: "number", min: 1, message: "Ranking must be at least 1" }
              ]}
            >
              <InputNumber
                size="large"
                placeholder="Enter ranking position"
                className="ranking-edit-input-override"
                style={{ width: "100%" }}
                min={1}
                max={10000}
              />
            </Form.Item>
            <p className="ranking-helper-text">
              💡 Enter a number to set the builder's ranking position
            </p>
          </div>

          {/* Action Buttons */}
          <Form.Item style={{ marginBottom: 0 }}>
            <div className="ranking-edit-actions">
              <Button
                size="large"
                onClick={onClose}
                className="ranking-edit-btn ranking-edit-btn-cancel"
              >
                Cancel
              </Button>
              <Button
                htmlType="submit"
                size="large"
                icon={<SaveOutlined />}
                className="ranking-edit-btn ranking-edit-btn-primary ranking-edit-btn-override"
              >
                <span>
                  Update Ranking
                </span>
              </Button>
            </div>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default RankingEditModal;